import { Map } from 'immutable';
import {
    SALES_TEAM_GET,
    SALES_TEAM_GET_ALL,
    SALES_TEAM_SET,
} from '../actions/sales';
import { APP_RESET } from '../actions/reset';
import { createActionHandler, createAsyncActionHandler } from './creator';

const initial = Map({
    isGettingTeams: false,
    teams: {
        data: [],
        totalCount: 0
    },
    teamList: []
});

const handlers = {
    ...createActionHandler(APP_RESET, () => initial),

    // 同步更新销售团队
    ...createActionHandler(SALES_TEAM_SET, (state: any, { payload }: Action.Sync) => state.merge({
        teamList: payload.teamList,
        teams: payload.teams
    })),

    // 获取销售团队（包含团队成员）
    ...createAsyncActionHandler(SALES_TEAM_GET, {
        init: (state: any) => state.merge({
            isGettingTeams: true
        }),
        succeeded: (state: any, action: Action.Sync) => state.merge({
            isGettingTeams: false,
            teams: action.payload
        }),
        failed: (state: any) => state.merge({
            isGettingTeams: false
        })
    }),

    // 创建销售团队列表
    ...createAsyncActionHandler(SALES_TEAM_GET_ALL, {
        init: (state: any) => state.merge({
            isGettingTeamList: true
        }),
        succeeded: (state: any, action: Action.Sync) => state.merge({
            isGettingTeamList: false,
            teamList: action.payload
        }),
        failed: (state: any) => state.merge({
            isGettingTeamList: false
        })
    })
};

export const system = initial;
export default (state = system, action: any = {}): any => {
    const fn = handlers[action.type];
    return fn ? fn(state, action) : state;
};
